import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ScreenHeading } from "../../componets/ScreenHeading/ScreenHeading";
import { ScrollService } from "../../componets/ScrollService";
import { Animations } from "../../componets/Animations";
import { Footer } from "../Footer/Footer";
import "./ContactUs.css";

export function ContactUs(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const form = useRef();
  const [emailSent, setEmailSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_rlx7ud4",
        "template_to3vf9t",
        form.current,
        "vjXDye68nzaw1752K"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent");
          alert("Email has been successfully sent!");
          setEmailSent(true);
          setTimeout(() => {
            setEmailSent(false);
            e.target.reset();
          }, 1000); // Reset form after 3 seconds
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className={"main-container fade-in"} id={props.id || ""}>
      <form ref={form} onSubmit={sendEmail}>
        <ScreenHeading title={"Contact Me"} subHeading={"Get in touch"} />
        <div className={"central-form"}>
          <label htmlFor={"name"}>Name</label>
          <input type="text" name="user_name" />

          <label htmlFor={"email"}>Email</label>
          <input type="email" name="user_email" />

          <label htmlFor={"message"}>Message</label>
          <textarea name="message" />

          <div className={"send-btn"}>
            <button type={"submit"}>Send</button>
          </div>
        </div>
      </form>

      <Footer />
    </div>
  );
}
